import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 1,
  class: "m-section"
}
const _hoisted_3 = { class: "m-blockNotice -warning" }
const _hoisted_4 = { class: "m-blockNotice__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleTicketTypeSelectionComponent = _resolveComponent("SingleTicketTypeSelectionComponent")!
  const _component_PriceLevelComponent = _resolveComponent("PriceLevelComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    id: "best-seat-selection",
    class: "o-seatSelection",
    "data-qa": _ctx.PerformanceQASelectors.BEST_SEAT_SELECTION
  }, [
    (_ctx.isSingleTicketTypeSelection)
      ? (_openBlock(), _createBlock(_component_SingleTicketTypeSelectionComponent, {
          key: 0,
          data: _ctx.data,
          eventName: _ctx.eventName
        }, null, 8, ["data", "eventName"]))
      : (_ctx.isPromotionWithoutAvailability)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives((_openBlock(), _createElementBlock("p", null, [
                  _createTextVNode("Tickets for activated promotion are currently not available.")
                ])), [
                  [_directive_translate, { key: _ctx.Translation.Notice_promotion_prices_not_available }]
                ])
              ])
            ])
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.data, (priceLevel) => {
            return (_openBlock(), _createBlock(_component_PriceLevelComponent, {
              data: priceLevel,
              eventName: _ctx.eventName,
              key: priceLevel.priceLevelId
            }, null, 8, ["data", "eventName"]))
          }), 128))
  ], 8, _hoisted_1))
}